import { AlertCircle } from 'lucide-react';

interface FieldErrorProps {
  message: string;
}

export function FieldError({ message }: FieldErrorProps) {
  if (!message) return null;

  return (
    <div className="flex items-center gap-1.5 mt-1.5">
      <AlertCircle size={12} className="text-red-500 flex-shrink-0" />
      <p className="text-xs text-red-500">{message}</p>
    </div>
  );
}
